import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Form, Col, Row, Button } from "react-bootstrap";
import "../../styles/customers/createCustomer.scss";
import { apiHost } from "../../api/apiClient";
import axios from "axios";
import queryString from "query-string";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";

class CreateAsset extends Component {

  Constants = { defaultProfile: "Truck" };

  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      customerId: "",
      customerName: "",
      name: "",
      friendlyName: "",
      tag1: "",
      tag2: "",
      description: "",
      profiles: [],
      profileId: "",
      profileName: "",
      color: "",
      icon: "",
      notes: "",
      adminNotes: "",
      status: [],
      statusId: 1,
      statusName: "Awaiting Install",
      error: false,
      micTick: false,
      sosTick: false,
      tempaTick: false,
      tempbTick: false,
      harshTick: false,
      driverTick: false,
      dashTick: false,
      customerError: false,
      nameError: false,
      tag1Error: false,
      tag2Error: false,
      descriptionError: false,
      profileError: false,
      featureError: false,
      colorError: false,
      iconError: false,
      noteError: false,
      adminNoteError: false,
      statusError: false,
    };
    this.micTick = false;
  }

  async componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    if (values.selectedAsset) {
      this.setState({
        customerName: values.selectedAsset,
        customerId: values.customerId,
      });
    }
    if (localStorage.getItem('role') === "SystemAdmin") {
      this.getCustomers();
    }
    this.getProfiles();
    this.getStatus();
  }

  getCustomers = async () => {
    this.props.setLoadingPageAction(true);
    try {
      const response = await axios.get(
        `${apiHost}/api/Customer/GetAllCustomers`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setState({ customers: response.data });
        this.props.setLoadingPageAction(false);
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  getProfiles = async () => {
    this.props.setLoadingPageAction(true);
    try {
      const response = await axios.get(`${apiHost}/api/Assets/GetAllProfile`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      if (response.status == "200") {
        this.setState({ profiles: response.data });
        this.props.setLoadingPageAction(false);
        this.state.profiles.forEach((profile) => {
          if (profile.profileName == this.Constants.defaultProfile) {
            this.setState({
              profileId: profile.id,
              profileName: profile.profileName,
            });
          }
        });
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  getStatus = async () => {
    this.props.setLoadingPageAction(true);
    try {
      const response = await axios.get(`${apiHost}/api/Assets/GetAllStatus`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      if (response.status == "200") {
        this.setState({ status: response.data });
        this.props.setLoadingPageAction(false);
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleCancel = () => {
    this.props.history.push("/customers");
  };

  handleName = (evt) => {
    if (evt.target.value == "") {
      this.setState({ nameError: true });
    } else {
      this.setState({ nameError: false });
    }
    this.setState({ name: evt.target.value });
  };

  handlefriendlyName = (evt) => {
    this.setState({ friendlyName: evt.target.value });
  };

  handleTag1 = (evt) => {
    this.setState({ tag1: evt.target.value });
  };

  handleTag2 = (evt) => {
    this.setState({ tag2: evt.target.value });
  };

  handleCustomer = (evt) => {
    console.log("handlel", evt.target.value)
    if (evt.target.value == "") {
      this.setState({ customerError: true });
    } else {
      this.setState({ customerError: false });
    }
    this.state.customers.forEach((customer) => {
      if (customer.name.trim() == evt.target.value) {
        this.setState({ customerId: customer.id })
      }
    });
  };

  handleDescription = (evt) => {
    this.setState({ description: evt.target.value });
  };

  handleProfile = (evt) => {
    this.state.profiles.forEach((profile) => {
      if (profile.profileName == evt.target.value) {
        this.setState({
          profileId: profile.id,
          profileName: profile.profileName,
        });
      }
      if (evt.target.value !== "") {
        this.setState({ profileError: false });
      }
    });
  };

  handleColor = (evt) => {
    this.setState({ color: evt.target.value });
  };

  handleIcon = (evt) => {
    this.setState({ icon: evt.target.value });
  };

  handleNotes = (evt) => {
    this.setState({ notes: evt.target.value });
  };

  handleAdminNotes = (evt) => {
    this.setState({ adminNotes: evt.target.value });
  };

  handleStatus = (evt) => {
    this.setState({ statusError: evt.target.value == "" });
    this.state.status.forEach((stats) => {
      if (stats.name == evt.target.value) {
        console.log(stats.name);
        this.setState({ statusId: stats.id, statusName: stats.name });
      }
    });
  };

  handleCreate = async () => {
    this.validationCheck();
    const {
      name,
      friendlyName,
      description,
      tag1,
      tag2,
      customerId,
      color,
      icon,
      notes,
      adminNotes,
      profileId,
      statusId,
      profileName,
      statusName,
    } = this.state;

    if (name && customerId && profileId && statusId) {
      this.props.setLoadingPageAction(true);

      try {
        const response = await axios.post(
          `${apiHost}/api/Assets/AssetRegister`,
          {
            Name: name,
            FriendlyName: friendlyName,
            Description: description,
            CustomerId: customerId,
            Tag1: tag1,
            Tag2: tag2,
            ProfilesId: profileId,
            ProfilesName: profileName,
            Features: 20,
            Colour: color,
            Icon: icon,
            Notes: notes,
            AdminNotes: adminNotes,
            StatusId: statusId,
            StatusName: statusName,
            ExternalId: 111,
            SpeakerandMic: this.state.micTick,
            SOSDuress: this.state.sosTick,
            TempA: this.state.tempaTick,
            TempB: this.state.tempbTick,
            HarshEvents: this.state.harshTick,
            DriverID: this.state.driverTick,
            DashCamera: this.state.dashTick,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        if (response.status == "200") {
          //this.props.history.push("/assets");
          this.props.history.goBack();
          this.props.setLoadingPageAction(false);
        }
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          // this.props.setErrorMessageAction(`${e}`);
          if (e.response.data.statusCode == "8") {
            this.props.setErrorMessageAction("Asset Already Exist");
          } else {
            this.props.setErrorMessageAction(`${e}`);
          }
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
        this.setState({ error_authorisation: true });
      }
    } else {
      this.setState({ error: true });
      setTimeout(() => {
        this.setState({ error: false });
      }, 3000);
    }
  };

  validationCheck = () => {
    if (!this.state.name) {
      this.setState({ nameError: true });
    }

    if (!this.state.customerId) {
      this.setState({ customerError: true });
    }

    if (!this.state.profileId) {
      this.setState({ profileError: true });
    }

    if (!this.state.statusId) {
      this.setState({ statusError: true });
    }
  };

  handleBack = () => {
    // this.props.history.push('/assets');
    this.props.history.goBack();
  };

  handleMic = (e) => {
    this.setState({ micTick: !this.state.micTick });
    this.micTick = !this.micTick;
  };
  handleSos = (e) => {
    this.setState({ sosTick: !this.state.sosTick });
  };

  handleTempA = (e) => {
    this.setState({ tempaTick: !this.state.tempaTick });
  };

  handleTempB = (e) => {
    this.setState({ tempbTick: !this.state.tempbTick });
  };

  handleHarsh = (e) => {
    this.setState({ harshTick: !this.state.harshTick });
  };

  handleDriver = (e) => {
    this.setState({ driverTick: !this.state.driverTick });
  };

  handleDash = (e) => {
    this.setState({ dashTick: !this.state.dashTick });
  };

  render() {
    const values = queryString.parse(this.props.location.search);
    const {
      customers,
      profiles,
      status,
      customerName,
      customerError,
      nameError,
      tag1Error,
      tag2Error,
      profileError,
      descriptionError,
      noteError,
      adminNoteError,
      iconError,
      colorError,
      statusError,
    } = this.state;

    var selectCustomerTag;
    if (values.selectedAsset) {
      selectCustomerTag = (
        <Form.Control
          as="select"
          onChange={this.handleCustomer}
          value={customerName}
        >
          <option value="default" disabled>
            Select Customer
          </option>
          {customers.map((customer, index) => (
            <option key={index}>{customer.name}</option>
          ))}
        </Form.Control>
      );
    } else {
      selectCustomerTag = (
        <Form.Control as="select" onChange={this.handleCustomer}>
          <option value="default">Select Customer</option>
          {customers.map((customer, index) => (
            <option key={index}>{customer.name}</option>
          ))}
        </Form.Control>
      );
    }

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>New Asset </title>
          </Helmet>
          <div>
            <div className="formGroup">
              <h1>New Asset</h1>
              <Form>
                <Form.Group as={Row} controlId="formPlainTimeZone">
                  <Form.Label column sm="2">
                    Customer
                  </Form.Label>
                  <Col sm="4">
                    {selectCustomerTag}
                    <p
                      style={
                        customerError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Customer field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    Name
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      onChange={this.handleName}
                      type="plaintext"
                      placeholder=""
                    />
                    <p
                      style={
                        nameError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Name field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    Friendly Name
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      onChange={this.handlefriendlyName}
                      type="plaintext"
                      placeholder=""
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    Tag1
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      onChange={this.handleTag1}
                      type="plaintext"
                      placeholder=""
                    />
                    <p
                      style={
                        tag1Error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Tag1 field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    Tag2
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      onChange={this.handleTag2}
                      type="plaintext"
                      placeholder=""
                    />
                    <p
                      style={
                        tag2Error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Tag2 field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    Description
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      as="textarea"
                      rows="3"
                      onChange={this.handleDescription}
                    />
                    <p
                      style={
                        descriptionError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Description field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlainTimeZone">
                  <Form.Label column sm="2">
                    Profile
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control as="select" onChange={this.handleProfile}>
                      <option value="default">Select Profile</option>
                      {profiles.map((profile, index) => (
                        <option selected={profile.profileName == this.Constants.defaultProfile ? "selected" : ""} key={index} value={profile.profileName} >{profile.profileName}</option>
                      ))}
                    </Form.Control>
                    <p
                      style={
                        profileError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Profile field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    Features
                  </Form.Label>
                  <Col sm="9">
                    <Form.Check
                      checked={this.state.micTick}
                      onChange={(e) => this.handleMic(e)}
                      inline
                      label="Speaker & Mic"
                      type="checkbox"
                    />
                    <Form.Check
                      checked={this.state.sosTick}
                      onChange={(e) => this.handleSos(e)}
                      inline
                      label="SOS (Duress) "
                      type="checkbox"
                    />
                    <Form.Check
                      checked={this.state.tempaTick}
                      onChange={(e) => this.handleTempA(e)}
                      inline
                      label="Temp A"
                      type="checkbox"
                    />
                    <Form.Check
                      checked={this.state.tempbTick}
                      onChange={(e) => this.handleTempB(e)}
                      inline
                      label="Temp B"
                      type="checkbox"
                    />
                    <Form.Check
                      checked={this.state.harshTick}
                      onChange={(e) => this.handleHarsh(e)}
                      inline
                      label="Harsh Events"
                      type="checkbox"
                    />
                    <Form.Check
                      checked={this.state.driverTick}
                      onChange={(e) => this.handleDriver(e)}
                      inline
                      label="Driver ID"
                      type="checkbox"
                    />
                    <Form.Check
                      checked={this.state.dashTick}
                      onChange={(e) => this.handleDash(e)}
                      inline
                      label="Dash Camera"
                      type="checkbox"
                    />
                    <div>
                      Value:<span>0</span>
                    </div>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    Color
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      onChange={this.handleColor}
                      type="plaintext"
                      placeholder=""
                    />
                    <p
                      style={
                        colorError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Color field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    Icon
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      onChange={this.handleIcon}
                      type="plaintext"
                      placeholder=""
                    />
                    <p
                      style={
                        iconError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Icon field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    Notes
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      as="textarea"
                      rows="3"
                      onChange={this.handleNotes}
                    />
                    <p
                      style={
                        noteError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Note field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlaintextName">
                  <Form.Label column sm="2">
                    Admin Notes
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      as="textarea"
                      rows="3"
                      onChange={this.handleAdminNotes}
                    />
                    <p
                      style={
                        adminNoteError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The AdminNote field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formPlainTimeZone">
                  <Form.Label column sm="2">
                    Status
                  </Form.Label>
                  <Col sm="4">
                    <Form.Control
                      as="select"
                      value={this.state.statusName}
                      onChange={this.handleStatus}
                    >
                      {status.map((stats, index) => (
                        <option key={index} value={stats.name}>
                          {stats.name}

                          {/* {  console.log('index',index)} */}
                        </option>
                      ))}
                    </Form.Control>
                    <p
                      style={
                        statusError
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Status field is required.
                    </p>
                  </Col>
                </Form.Group>

                <Row>
                  <Col sm="2"></Col>
                  <Col sm="9">
                    <Button variant="light" onClick={this.handleBack}>
                      Back to List
                    </Button>
                    <Button variant="primary" onClick={this.handleCreate}>
                      Create
                    </Button>
                  </Col>
                </Row>
                {this.state.error && (
                  <Row>
                    <Col sm="2"></Col>
                    <Col sm="9">
                      <p className="error-text">
                        Please fill all the Required fields
                      </p>
                    </Col>
                  </Row>
                )}

                {/* <Form.Group as={Row} controlId="formPlainAddress">
               <Form.Label  column sm="2">Address</Form.Label>
               <Col sm="4">
               <div>Position (<span>{lat}, {lng})</span></div>
               <div>{address}</div>
               </Col>
              </Form.Group>  */}
              </Form>
              <br />
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});

const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateAsset);
